import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
    constructor(private spinner: NgxSpinnerService) {}

    // Helper to get CSRF token from cookies
    getCookie(name: string): string | null {
        const matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : null;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.show();

        // Add CSRF token to non-GET requests
        const csrfToken = this.getCookie('csrftoken');
        let modifiedReq = req;

        if (csrfToken && !['GET', 'HEAD'].includes(req.method)) {
            modifiedReq = req.clone({
                headers: req.headers.set('X-CSRFToken', csrfToken),
                withCredentials: true  // Ensure cookies are sent
            });
        }

        return next.handle(modifiedReq).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.spinner.hide();
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.spinner.hide();
                console.error(`Request failed: ${req.urlWithParams}`, error);
                return throwError(error);
            })
        );
    }
}
